import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-rocs',
  templateUrl: './rocs.component.html',
  styleUrls: ['./rocs.component.scss']
})
export class RocsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
